import * as React from 'react';
import { LinkedText } from './LinkedText';

interface ComparisonRow {
  topic: string;
  supermarket: string;
  ours: string;
}

interface ComparisonSectionProps {
  rows: ComparisonRow[];
  changomas: { heading: string; body: string };
}

export function ComparisonSection({ rows, changomas }: ComparisonSectionProps) {
  return (
    <section className="whyus-compare">
      <style>{`
        .whyus-compare {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .whyus-compare-inner {
          max-width: 960px;
          margin: 0 auto;
        }
        .whyus-compare h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 12px;
          line-height: 1.3;
        }
        .whyus-compare .lead {
          font-size: 16px;
          color: #555;
          line-height: 1.6;
          margin: 0 0 24px;
          max-width: 720px;
        }
        .whyus-table-wrap {
          overflow-x: auto;
          border: 1px solid #eee;
          border-radius: 12px;
          background: #fff;
        }
        .whyus-table {
          width: 100%;
          border-collapse: collapse;
          min-width: 640px;
        }
        .whyus-table caption {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          border: 0;
        }
        .whyus-table th,
        .whyus-table td {
          text-align: left;
          vertical-align: top;
          padding: 14px 16px;
          font-size: 15px;
          line-height: 1.55;
          border-bottom: 1px solid #eee;
        }
        .whyus-table th {
          font-size: 13px;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          color: #666;
          background: #fafaf7;
        }
        .whyus-table tbody th {
          font-weight: 700;
          color: #1a1a1a;
          width: 22%;
          text-transform: none;
          letter-spacing: 0;
          font-size: 15px;
          background: transparent;
        }
        .whyus-table tr:last-child td {
          border-bottom: none;
        }
        .whyus-changomas {
          margin-top: 36px;
          max-width: 720px;
        }
        .whyus-changomas h3 {
          font-size: 20px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 10px;
        }
        .whyus-changomas p {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0;
        }
        @media (max-width: 640px) {
          .whyus-compare h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="whyus-compare-inner">
        <h2>Súper online vs. Abasto Virtual: las diferencias que importan en lo fresco</h2>
        <p className="lead">
          No comparamos precios. Comparamos qué pasa con el pedido: si falta algo, quién lo lleva y qué hacemos si llega mal.
        </p>
        <div className="whyus-table-wrap">
          <table className="whyus-table">
            <caption className="sr-only">
              Diferencias de política entre un súper online y Abasto Virtual
            </caption>
            <thead>
              <tr>
                <th scope="col">Tema</th>
                <th scope="col">Súper online</th>
                <th scope="col">Abasto Virtual</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.topic}>
                  <th scope="row">{row.topic}</th>
                  <td><LinkedText text={row.supermarket} /></td>
                  <td><LinkedText text={row.ours} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="whyus-changomas">
          <h3>{changomas.heading}</h3>
          <p><LinkedText text={changomas.body} /></p>
        </div>
      </div>
    </section>
  );
}
